import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-unsubscribe',
  imports: [HttpClientModule, CommonModule],
  templateUrl: './unsubscribe.html',
  styleUrl: './unsubscribe.scss',
})
export class Unsubscribe implements OnInit {
  userId: string = '';
  isSubscribed: boolean = false;
  isLoading = false;
  isToggling = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    // Get userId from route parameters
    this.userId = this.route.snapshot.paramMap.get('userId') || '';

    if (!this.userId) {
      this.errorMessage = 'Invalid unsubscribe link. Please contact support.';
      return;
    }

    // Fetch subscription status
    this.fetchSubscriptionStatus();
  }

  private fetchSubscriptionStatus() {
    this.isLoading = true;
    this.errorMessage = '';

    this.http
      .get(`${this.getApiBaseUrl()}/subscription`, {
        headers: {
          'x-client-id': this.userId,
        },
      })
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.isSubscribed = response.data?.subscribed || false;
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Fetch subscription error:', error);

          if (error.status === 404) {
            this.errorMessage =
              'User not found. Please check your unsubscribe link.';
          } else if (error.status === 0 || !error.status) {
            this.errorMessage =
              'Unable to connect to the server. Please check your connection and try again.';
          } else {
            this.errorMessage =
              error.error?.message ||
              'An error occurred while fetching subscription status.';
          }
        },
      });
  }

  toggleSubscription() {
    if (this.isToggling) return;

    this.isToggling = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.http
      .patch(
        `${this.getApiBaseUrl()}/subscription`,
        {},
        {
          headers: {
            'x-client-id': this.userId,
          },
        }
      )
      .subscribe({
        next: (response: any) => {
          this.isToggling = false;
          this.isSubscribed = response.data?.subscribed || false;
          this.successMessage = this.isSubscribed
            ? 'You have been successfully subscribed to our updates!'
            : 'You have been successfully unsubscribed from our updates.';
        },
        error: (error) => {
          this.isToggling = false;
          console.error('Toggle subscription error:', error);

          if (error.status === 404) {
            this.errorMessage =
              'User not found. Please check your unsubscribe link.';
          } else if (error.status === 0 || !error.status) {
            this.errorMessage =
              'Unable to connect to the server. Please check your connection and try again.';
          } else {
            this.errorMessage =
              error.error?.message ||
              'An error occurred while updating subscription status.';
          }
        },
      });
  }

  private getApiBaseUrl(): string {
    return environment.apiUrl;
  }
}
